// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/css/font-awesome.min.css
// module id = 502
// module chunks = 1